import { render, staticRenderFns } from "./PrizeManagement.vue?vue&type=template&id=c96e2082"
import script from "./prize-management.ts?vue&type=script&lang=ts&external"
export * from "./prize-management.ts?vue&type=script&lang=ts&external"
import style0 from "./prize-management.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports